import { Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import { componentMapper, ComponentMapperKeys } from "../../../constant";

const RowWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      padding="16px 16px 16px 0"
      borderBottom="1px solid #0000001F"
      gap="16px"
    >
      {children}
    </Stack>
  );
};

export const RolePlanTable = ({
  rows,
  columns,
}: {
  columns: { maxWidth: string; value: string }[];
  rows: {
    type: ComponentMapperKeys;
    value: never;
    items: { type: ComponentMapperKeys; value: never }[];
  }[][];
}) => {
  if (!Array.isArray(rows) || !Array.isArray(columns)) return null;
  return (
    <Stack>
      <RowWrapper>
        {columns.map(({ maxWidth, value }) => (
          <Typography
            key={value}
            sx={{
              fontSize: "16px",
              lineHeight: "24px",
              fontWeight: 500,
              color: "#1F2932",
              maxWidth,
              width: "100%",
            }}
          >
            {value}
          </Typography>
        ))}
      </RowWrapper>
      {rows.map((row, index) => (
        <RowWrapper key={index}>
          {row.map(({ type, value, items }, i) => (
            <Stack
              maxWidth={columns[i].maxWidth}
              width="100%"
              alignSelf="flex-start"
              gap="8px"
            >
              {value && type && componentMapper[type](value as any)}
              {items &&
                Array.isArray(items) &&
                items.map(({ type, value }) => {
                  if (!type || !value) return null;
                  return componentMapper[type](value as any);
                })}
            </Stack>
          ))}
        </RowWrapper>
      ))}
    </Stack>
  );
};
